import { useEffect, useState } from 'react';
const Online = () => {
  const [offer, setOffers] = useState([]);
  useEffect(() => {
    fetch('/data/offer.json')
      .then((res) => res.json())
      .then(setOffers)
      .catch(console.error);
  }, []);
  if (!offer) return <p>Ładowanie danych…</p>;
  const trainig = offer?.data?.find((o) => o.name === 'ONLINE');
  const singleTrainingPrice = trainig?.offers.find((o) => o.period === 1).price;
  return (
    <div class="max-w-3xl mx-auto space-y-6">
      <h1 class="text-4xl font-bold text-center mb-4 mt-4">
        WSPÓŁPRACA ONLINE
      </h1>
      <h3 class="text-1xl text-center mb-8 mt-4 text-gray-300">
        W pełni spersonalizowany plan treningowy i dietetyczny, dopasowany do
        Twoich celów i dostępnych zasobów. Współpraca online to doskonała opcja,
        jeśli chcesz trenować w komfortowych warunkach, ale bez utraty
        efektywności.
      </h3>
      <div class="grid grid-cols-1 gap-6">
        {trainig?.offers.map((i, index) => (
          <div
            key={index}
            class="bg-gray-800 p-8 rounded-3xl shadow-xl flex flex-col justify-between"
          >
            <div>
              <h2 class="text-2xl font-semibold mb-2">{i.name}</h2>
              <p class="text-lg font-bold">
                {i.price} zł
                {i.period > 1 && (
                  <span class="text-green-400 text-base">
                    {' ('}
                    oszczędzasz
                    <b>
                      {' '}
                      {singleTrainingPrice * i.period - i.price} zł
                      {')'}
                    </b>
                  </span>
                )}
              </p>
            </div>
          </div>
        ))}
        {/* <div class="bg-gray-800 p-6 rounded-2xl shadow-lg">
          <h2 class="text-2xl font-semibold mb-2">1 miesiąc</h2>
          <p class="text-lg font-bold">300 zł</p>
        </div>
        <div class="bg-gray-800 p-6 rounded-2xl shadow-lg">
          <h2 class="text-2xl font-semibold mb-2">3 miesiące</h2>
          <p class="text-lg font-bold">
            700 zł{' '}
            <span class="text-green-400 text-base">(oszczędzasz 200 zł)</span>
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default Online;
